import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=c181d15c"
import script from "./Wizard.vue?vue&type=script&lang=ts"
export * from "./Wizard.vue?vue&type=script&lang=ts"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=c181d15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports